export default __webpack_public_path__ + "static/media/img-time-l-4.f880e96f.svg";